exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.assignment-pullout{position:absolute;right:0;top:70px;height:65px;background-color:#fff;z-index:35;display:flex;align-items:center}.assignment-pullout .avatar-holder{position:relative;margin-left:16px}.assignment-pullout .avatar-holder .user-avatar{margin-right:0}.assignment-pullout .instruction-text{position:relative;margin-left:16px;font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#4a4a4a}.assignment-pullout .instruction-text--bold{font-weight:800}.assignment-pullout .save-button{position:relative;margin-left:16px;width:84px;height:32px;background-color:transparent;border:1px solid #4bb543;border-radius:4px;font-family:Open Sans,sans-serif;font-size:12px;color:#4bb543;text-align:center;font-weight:700;line-height:24px;box-sizing:border-box;padding-top:4px}.assignment-pullout .save-button.enabled{cursor:pointer;background-color:#4bb543;color:#fff}.assignment-pullout .cancel-button{position:relative;width:14px;height:14px;margin:0 16px;background-image:url(" + require("../../../assets/images/cancel-icon-gray.svg") + ");background-repeat:no-repeat;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectsContainer/AssignmentPullout/AssignmentPullout.scss
// module id = 1801
// module chunks = 0